import { render } from "./TrashViewOld.vue?vue&type=template&id=5071a2af"
import script from "./TrashViewOld.vue?vue&type=script&lang=js"
export * from "./TrashViewOld.vue?vue&type=script&lang=js"

import "./TrashViewOld.vue?vue&type=style&index=0&id=5071a2af&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__